import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import { adminApi, startGoogleLogin } from '../services/adminApi';
import { Dashboard } from '../components/admin/Dashboard';

const LoginCard = () => (
  <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6" data-testid="admin-login">
    <div className="bg-white border border-neutral-200 border-t-4 border-t-red-600 shadow-xl rounded-sm p-10 max-w-sm w-full text-center">
      <img src="/images/logo.png" alt="Stefen's Detailing" className="h-16 w-auto mx-auto mb-4" />
      <h1 className="font-display italic uppercase text-3xl font-extrabold text-neutral-950 mb-2">Owner Login</h1>
      <p className="text-neutral-600 text-sm mb-6">Private dashboard for Stefen&apos;s Detailing.</p>
      <button type="button" onClick={startGoogleLogin} data-testid="admin-google-login-btn"
        className="w-full inline-flex items-center justify-center gap-2 bg-neutral-950 hover:bg-neutral-800 text-white font-semibold py-3 rounded-sm">
        <Lock className="w-4 h-4" /> Sign in with Google
      </button>
    </div>
  </div>
);

export default function AdminPage() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [checked, setChecked] = useState(Boolean(location.state?.user));

  useEffect(() => {
    if (location.state?.user) return;
    adminApi.me().then(setUser).catch(() => setUser(null)).finally(() => setChecked(true));
  }, [location.state]);

  const logout = async () => {
    await adminApi.logout().catch(() => {});
    setUser(null);
  };

  if (!checked) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-red-600" /></div>;
  }
  return user ? <Dashboard user={user} onLogout={logout} /> : <LoginCard />;
}
